import React from 'react';
import { Typography } from 'antd';
import { TitleProps } from 'antd/lib/typography/Title';

export type { TitleProps };

const ProTypographyTitle: React.FC<TitleProps> = (props) => {
  const { children, ...resProps } = props;

  return <Typography.Title {...resProps}>{children}</Typography.Title>;
};

export default ProTypographyTitle;
